import { type KeyboardEvent } from 'react';
import { StorageService } from '@nextgen-web-framework/core';
import {
  CTAEventType,
  CartConstantsEnum,
  KeyboardKeys,
  ListEntry,
  Price,
  Product,
  PromotionResults,
} from '@commerce-cart-webcomponents/sdk';
import { DerivedAvailabilityStatus, productApi, ProductType } from '@commerce-product-webcomponents/sdk';
import type { Tuple } from '@nextgen-web-framework/core';

interface LoginState {
  headers: Tuple;
  redirectUri: string;
  loginUrl?: string;
  amwayLang?: string;
}

export const checkKeyPressOrClick = (
  e: KeyboardEvent<HTMLInputElement> | React.MouseEvent<HTMLSpanElement, MouseEvent>,
  key: KeyboardKeys,
) => ('key' in e && e.key === key) || e.type === CTAEventType.CLICK;

export const disableProduct = (entry: ListEntry) => {
  if (
    entry.product.derivedAvailabilityStatus === DerivedAvailabilityStatus.Nla ||
    entry.product.derivedAvailabilityStatus === DerivedAvailabilityStatus.OutOfStock ||
    entry.product.derivedAvailabilityStatus === DerivedAvailabilityStatus.Nya
  ) {
    return true;
  }

  return false;
};

export const getProductDataById = (productId: string) =>
  productApi.getProductByIdOrError({
    productId,
    warehouseId: StorageService.getLocalStorage().retrieve(CartConstantsEnum.WarehouseId),
  });

export const getLoginProps = (currentLocale: string) => {
  const tuples = ApiConfigService.getTuples();
  const configs = ConfigService.getConfigs();
  let postAuthUrl = '';
  if (typeof window !== 'undefined') {
    const loginState: LoginState = {
      redirectUri: window.location.href,
      headers: tuples,
      amwayLang: currentLocale,
    };
    if (configs.NEXT_PUBLIC_LOGIN_URL) {
      loginState.loginUrl = configs.NEXT_PUBLIC_LOGIN_URL as string;
    }
    postAuthUrl = btoa(JSON.stringify(loginState));
  }
  return {
    scope: 'openid',
    state: postAuthUrl,
    countryIso: tuples['X-Amway-Country'],
    redirectUri: configs.NEXT_PUBLIC_OIDC_URL ? `${configs.NEXT_PUBLIC_OIDC_URL}` : '',
  };
};

export const createDataObject = (
  product?: Product,
  totalPrice?: Price,
  promotionResults?: PromotionResults,
  isABO?: boolean,
  hideBV = false,
) => {
  const { pointValue = 0, businessVolume = 0 } = totalPrice?.amwayValue || {};
  return {
    productSize: product?.copyServingSize ?? '',
    brandName: (product?.brand as string) ?? '',
    productId: (product?.id as string) ?? '',
    itemDisposition:
      (product?.type === ProductType.Bundle ? product?.derivedAvailabilityStatus : product?.itemDisposition) ?? '',
    productPrice: totalPrice?.value as number,
    currency: totalPrice?.currency,
    pointValue: isABO ? String(pointValue) : '',
    businessVolume: isABO && !hideBV ? String(businessVolume) : '',
    potentialPromotions: promotionResults?.potentialPromotions,
  };
};
